import React,{useState} from 'react'
import '../pages/Team.css'


import AOS from "aos";
import "aos/dist/aos.css"; 

AOS.init({
  duration: 1000, 
  easing: "ease-in-out", 
});

const TeamCard = ({name,position,imageLink,gmail,linkedin,github}) => {
 
  return (
    <div className="card_team shadow" data-aos="flip-up"
    data-aos-anchor-placement="top-center">
              <div className="profile-img" style={{padding:"6px"}}>
                <img src={imageLink} className="rounded-circle" alt='myimg' />
              </div>
              <div className="content">
                <h3 style={{padding:"1px"}}>{name}</h3>
                <p>{position}</p>
                <hr />
                <div className="social-media">
                <a href={`mailto:${gmail}`} target='_blank'><i
                    className="fa fa-envelope"
                    style={{ color: "red", fontSize: "32px" }}
                  ></i></a>
                  <a href={linkedin} target='_blank'><i
                    className="fa fa-linkedin-square"
                    style={{ fontSize: "32px", color: "blue" }}
                  ></i></a>
                  <a href={github} target='_blank'><i
                    className="fa fa-github"
                    style={{ fontSize: "32px", color: "black" }}
                  ></i></a>
                </div>
              </div>
            </div>
  )
}

export default TeamCard
